<template>
  <PlaceholderPantalla
    titulo="Flujo de Caja"
    subtitulo="Proyección y análisis del movimiento de efectivo"
    descripcion="Visualiza y proyecta el flujo de efectivo de tu negocio. Esta herramienta te permite analizar entradas y salidas de dinero, proyectar el flujo para los próximos meses basado en históricos y compromisos, identificar períodos críticos de liquidez, y tomar decisiones informadas sobre inversiones y financiamiento."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../PlaceholderPantalla.vue'

const funcionalidades = [
  'Dashboard visual del flujo de caja actual con gráficas interactivas',
  'Proyección automática de flujo de caja a 3, 6 y 12 meses',
  'Cálculo basado en: ingresos históricos, gastos recurrentes, cuentas por cobrar/pagar',
  'Análisis de entradas vs salidas por período (diario, semanal, mensual)',
  'Identificación de períodos críticos con saldo negativo proyectado',
  'Simulador de escenarios (optimista, realista, pesimista)',
  'Alertas de déficit de efectivo proyectado',
  'Comparación de flujo real vs proyectado',
  'Gráfica de tendencia de saldo en cuenta',
  'Análisis de estacionalidad del negocio',
  'Recomendaciones automáticas de acciones a tomar',
  'Exportar proyecciones a Excel y PDF',
  'Configuración de parámetros de proyección'
]

const datosManejados = [
  'Saldo inicial por período',
  'Ingresos proyectados por categoría',
  'Gastos proyectados por categoría',
  'Cuentas por cobrar programadas',
  'Cuentas por pagar programadas',
  'Transferencias programadas',
  'Saldo final proyectado',
  'Déficit o superávit por período',
  'Tendencias históricas',
  'Estacionalidad del negocio',
  'Parámetros de proyección (% crecimiento, inflación, etc.)',
  'Escenarios alternativos'
]
</script>
